import { useEffect, useState } from 'react'
import { applyTokensToDocument, DEFAULT_TOKENS, loadTokens, StyleTokens } from '@/lib/styleTokens'

/**
 * StylesProvider — loads saved style tokens from MongoDB on mount,
 * applies them as CSS variables to the document root so the entire site
 * inherits the customised values.
 *
 * Renders nothing visible. Place once at the root of the app.
 */
function StylesProvider() {
  const [, setTokens] = useState<StyleTokens>(DEFAULT_TOKENS)

  useEffect(() => {
    // Apply defaults immediately so first paint is correct
    applyTokensToDocument(DEFAULT_TOKENS)

    // Then load saved tokens from DB and override
    loadTokens().then(({ tokens }) => {
      setTokens(tokens)
      applyTokensToDocument(tokens)
    })
  }, [])

  return null
}

export default StylesProvider
